import React from 'react';
import { Layout } from 'antd';
import Navbar from './Navbar';

const { Header } = Layout;

const AppHeader = () => {
    return (
        <Header>
            <div className="logo" />
            <Navbar />
        </Header>
    );
};

export default AppHeader;
